import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { formatMidiDuration, countMidiNotes } from '../../utils/midiJson';

import './MidiSummary.scss';

/*
 * What a clip is, above the keyboard: the three numbers worth knowing.
 *
 *   DURATION      BPM      NOTES
 *     0:32        92        184
 */
const MidiSummary = ({ midiJson, duration }) => {
  const { t } = useTranslation();

  if (!midiJson) return null;

  return (
    <div className="MidiSummary">
      <dl className="stats">
        <div>
          <dt>{t('dialogs.midi.duration')}</dt>
          <dd>{formatMidiDuration(duration ?? midiJson.duration)}</dd>
        </div>
        <div>
          <dt>BPM</dt>
          <dd>{midiJson.bpm}</dd>
        </div>
        <div>
          <dt>{t('dialogs.midi.notes')}</dt>
          <dd>{countMidiNotes(midiJson)}</dd>
        </div>
      </dl>
    </div>
  );
};

MidiSummary.propTypes = {
  midiJson: PropTypes.object,
  duration: PropTypes.number,
};

export default MidiSummary;
